import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function InstitutionError(props) {
    return (
        <Container>
            <Row>
                <Col sm={{ size: 10, offset: 1 }} lg={{ size: 8, offset: 2 }}>
                    <Card className="shadow text-center">
                        <CardHeader>
                            <CardTitle>
                                <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="institutionErrorNoTitle" defaultMessage="Something wrong..." />
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <p>
                                <FormattedMessage id="institutionErrorNoText" defaultMessage="Your account is not associated to any institutions. Please contact us to fix this problem." />
                            </p>
                            <ButtonGroup>
                                <Button to={'/page/contact'} tag={Link} color="info" outline><FontAwesomeIcon icon="envelope" /> <FormattedMessage id="contactPageTitle" defaultMessage="Contact us" /></Button>
                            </ButtonGroup>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default withIntl(InstitutionError);
